import { render, staticRenderFns } from "./EditRegularLessonCard.vue?vue&type=template&id=259ee5be&scoped=true&"
import script from "./EditRegularLessonCard.vue?vue&type=script&lang=js&"
export * from "./EditRegularLessonCard.vue?vue&type=script&lang=js&"
import style0 from "./EditRegularLessonCard.vue?vue&type=style&index=0&id=259ee5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ee5be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})
